<mat-form-field>
    <mat-label>Category</mat-label>
    <mat-select [(value)]="selected" [panelClass]="panelClass" placeholder="Category" panelClass="wider-dropdown"
        (selectionChange)="valueChanged()">
        <mat-option [value]="null"><em>All Categories</em></mat-option>
        <mat-option *ngFor="let category of errorCategories" [value]="category">
            {{ category | errorCategory }}
        </mat-option>
    </mat-select>
</mat-form-field>